import * as React from "react"

type Props = {
  title: string
  description?: string
}

export const Head:React.FunctionComponent<Props> = ({title, description}) => (
    <>
        <title>{title}</title>
        <meta name="description" content={description}/>
    </>
)
